import { compareDesc } from 'core/utils/date'

export const enum BidState {
  Closed = 'closed',
  Open = 'open',
  Submitted = 'submitted',
  Results = 'results',
}

export type BidStateFilter = BidState | 'all'

export const enum RfpState {
  Archived = 'archived',
  Awarding = 'awarding',
  Closed = 'closed',
  Draft = 'draft',
  Finalized = 'finalized',
  Published = 'published',
}

export const enum CarrierInviteState {
  Accepted = 'accepted',
  AwardFinished = 'award_finished',
  CheckContact = 'check_contact',
  NotInvited = 'not_invited',
  Pending = 'pending',
  Sent = 'sent',
  Submitted = 'submitted',
  Unsubscribed = 'unsubscribed',
}

export type RfpSummary = {
  rfpId: number
  rfpName: string
  rfpState: RfpState
  rfpRequestDeadline: Date
  rfpContractStart: Date
  rfpContractEnd: Date
  shipperName: string
  lanesCount: number
  laneProposalsCount: number
  awardedLaneProposalsCount: number
  pendingAwardedLaneProposalsCount: number
  awardConfirmationDeadline: Date | undefined
  carrierInviteState: CarrierInviteState // the "carrierInviteState" maps to the raw "state" field
  inviteId: string
  inviteLinkUuid: string
  bidState: BidState
}

export function hasValidDeadline(rfpRequestDeadline: Date) {
  return compareDesc(new Date(), rfpRequestDeadline) === 1
}

export function hasRfpItems(rfpList?: Array<RfpSummary>) {
  if (!rfpList) return false

  return rfpList.length > 0
}

export function filterByBidState(rfpSummaryList: Array<RfpSummary> = [], bidState: string = 'all') {
  if (bidState === 'all') return rfpSummaryList

  return rfpSummaryList.filter(rfpSummary => rfpSummary.bidState === bidState)
}

export function findOneByBidState(rfpSummaryList: Array<RfpSummary>, bidState: string) {
  return rfpSummaryList.find(rfpSummary => rfpSummary.bidState === bidState)
}

export function hasCarrierAcceptedRfp(carrierInviteState: CarrierInviteState) {
  return [CarrierInviteState.Accepted, CarrierInviteState.Submitted].includes(carrierInviteState)
}

export function hasCarrierSubmittedRfp(carrierInviteState: CarrierInviteState) {
  return carrierInviteState === CarrierInviteState.Submitted
}

export function isAwardFinished(carrierInviteState: CarrierInviteState) {
  return carrierInviteState === CarrierInviteState.AwardFinished
}
